import { createSlice } from '@reduxjs/toolkit'

export const chooseItemGroupSlice = createSlice({
  name: 'chooseItemGroup',
  initialState: {
    value: {}
  },
  reducers: {
    setItemGroups: (state, action) => {
      state.value = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setItemGroups } = chooseItemGroupSlice.actions

export default chooseItemGroupSlice.reducer